'use client';
import { css, getColorByToken } from '@wanteddev/wds-engine';
import { createResponsiveStyle, getPreviousValue } from '../../utils/responsive-props.mjs';

// src/components/divider/style.ts
var dividerStyle = ({ vertical, color, size, thickness, xs, sm, md, lg, xl }) => (theme) => css`
    margin: 0px;
    border-style: solid;
    border-color: ${getColorByToken(theme, color)};

    ${dividerSizeStyle({ size, vertical, thickness })}

    ${createResponsiveStyle(
  { xs, sm, md, lg, xl },
  theme
)(
  (params, breakpoint) => css`
        ${dividerSizeStyle({
    size: getPreviousValue(
      { xs, sm, md, lg, xl },
      "size",
      size,
      breakpoint
    ),
    thickness: getPreviousValue(
      { xs, sm, md, lg, xl },
      "thickness",
      thickness,
      breakpoint
    ),
    vertical: getPreviousValue(
      { xs, sm, md, lg, xl },
      "vertical",
      vertical,
      breakpoint
    )
  })}
        ${params?.sx}
      `
)}
  `;
var dividerSizeStyle = ({
  size,
  thickness,
  vertical
}) => css`
  ${Boolean(thickness) && (vertical ? css`
        border-width: 0px;
        border-right-width: ${thickness};
      ` : css`
        border-width: 0px;
        border-bottom-width: ${thickness};
      `)}

  ${vertical ? css`
        width: 0px;
        height: ${size};
      ` : css`
        height: 0px;
        width: ${size};
      `};
`;

export { dividerStyle };
